(() => {
  if (window.NimoLeadRouting) return;

  const API_REVISION = '2026-07-15';

  async function subscribeToKlaviyoList({ companyId, listId, email, source, properties = {} }) {
    if (!companyId || !listId || !email) return false;

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
      {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          revision: API_REVISION,
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    properties,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED',
                        },
                      },
                    },
                  },
                },
              },
              custom_source: source,
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`Klaviyo subscription failed with status ${response.status}`);
    }

    return true;
  }

  function markSuccessInUrl(parameter, value = 'true', hash = '') {
    if (!parameter) return;

    const url = new URL(window.location.href);
    url.searchParams.set(parameter, value);
    if (hash) url.hash = hash;
    window.history.replaceState({ ...window.history.state, [parameter]: value }, '', url);
  }

  window.NimoLeadRouting = {
    markSuccessInUrl,
    subscribeToKlaviyoList,
  };
})();
